<template id="home-dashboard">
  <section>
    <div class="card-deck m-2">
      <template v-if="call">
        <dc-vizlet v-for="(r,index) in homeData" v-bind:key="index" :dc-viz="r"></dc-vizlet>
      </template>
    </div>


  </section>
</template>
<script>

//import axios from 'axios'

// import {bus} from "@/bus"
import dcVizlet from '@/components/dc-vizlet'

export default {
  name: 'home-dashboard',
  components: {dcVizlet},

  data: () => ({

    call: null,
    res: '',
    levelOnePeriodData: [],
    annotations: [],
    filterPeriodLevel1: '',
    filterPeriodLevel2: 'quarterly',
    //filterPeriodLevel2: 'weekly',
    //filterPeriodLevel2: 'monthly',
    searching: false,
    annotationTitle: '',
    reportTitle: '',
    dataSqlId: '',
    viztypeClassName: '',
    homeData: {},
    allSummaryData: null
  }),
  computed: {},
  beforeMount() {
    //Check if the role home dashboard menu id is pointed to different URL
      if( this.$store.state.user.userRoleRestriction.homeDashboardMenuId && this.$store.state.user.userRoleRestriction.homeDashboardMenuId.includes('/')){
        console.log("router push home")
        this.$router.push(this.$store.state.user.userRoleRestriction.homeDashboardMenuId)
      }
  },
  created () {
    let l = setInterval(() => {
      if (this.$store.state.stateLoaded) {
          this.loadHomeConfig()
          this.listenToRouter()
          clearInterval(l)

      } else {
        console.log('state is not loaded...')
      }
    }, 300)
  },
  methods: {
    periodLOne: function () {
      this.filterPeriodLevel2 = 'quarterly'
      //this.filterPeriodLevel2 = 'weekly'
      //this.filterPeriodLevel2 = 'monthly'
      this.dcSummaryCharts()
      //  this.updateReportData()
    },
    periodLTwo: function () {
      this.dcSummaryCharts()
    },
    loadHomeConfig: function () {
      this.$store.dispatch('loadState').then(() => {
        this.configData = this.$store.state.fwConfigScreenElement
        //let submenuParam = this.$route.params.submenuId
        let submenuParam = this.$store.state.user.userRoleRestriction.homeDashboardMenuId
        console.log('Route Param', submenuParam)
        this.homeData = this.configData.filter(r => r.menuId === submenuParam)
        console.log('All Home config data are:', this.homeData)

        let allViztypeData = this.$store.state.vizType
        let viztypeDataList = allViztypeData.filter((t) => t.viztypeId === 'V77')
        if (viztypeDataList.length > 0) {
          let viztypeData = viztypeDataList[0]
          if (this.homeData.length > 0) {

            this.dataSqlId = this.homeData[0].datasqlId
            this.viztypeClassName = viztypeData.viztypeClassName
            console.log('vizClassName ', this.viztypeClassName)

            console.log('ALl vizData is', this.configData, this.dataSqlId, this.viztypeClassName)
            //this.loadSummary()
            this.$commonFn.crossfilterDatafetch(this.dataSqlId, this.viztypeClassName).then(res => {
              this.call = 'true'
              console.log('value of fun call', res, this.call)
            })

          }
        }
      })

    },
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)

        setTimeout(() => {
          $this.loadHomeConfig()
        }, 300)

      })
    }
  }
}
</script>
